/*
* Ryan O'Dowd
* 2021-04-09
* © Copyright 2021 Oakwood Software Consulting, Inc.  All Rights Reserved.
*/
import fb from '@utils/firebase';
import {
  store,
} from '@utils/store';
import {
  uploadImage,
} from '@utils/store/actions';

export default function uploadPhoto(base64String, imageDimension, putUrl, onUploadStart, onUploadEnd) {
  // from chatgpt
  new Promise((resolve, reject) => {
    onUploadStart();
    const img = new Image();
    img.src = base64String;

    img.onload = () => {
      let width = img.width;
      let height = img.height;

      // Resize maintaining aspect ratio
      if (width > height) {
        if (width > imageDimension) {
          height = Math.round((height *= imageDimension / width));
          width = imageDimension;
        }
      } else {
        if (height > imageDimension) {
          width = Math.round((width *= imageDimension / height));
          height = imageDimension;
        }
      }

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      const resizedBase64 = canvas.toDataURL('image/jpeg', 0.75);
      resolve(resizedBase64);
    };

    img.onerror = reject;
  }).then((resizedImage: any) => {
    store.dispatch(uploadImage(resizedImage.split(',')[1], putUrl, () => onUploadEnd()));
  }).catch((err) => {
    fb.log(fb.crashlytics, `ImageResizer error: \`${err}\``);
    fb.recordError(fb.crashlytics, err);
    onUploadEnd();
  });
}
